<template>
	<el-dialog title="分组详情" :before-close="cancel" append-to-body :visible.sync="voteResultDialogVisible"
		width="1250px" center>
		<!-- {{voteDetail}} -->
		<!-- type="border-card" -->
		<div class="vote-result">
			<!-- <div class="flex align-center justify-between">
				<div class="vote-title">
					<h4>是否有弃权: {{ voteDetail.allowWaive ? '是' : '否' }}</h4>
					<h4>是否显示占比: {{ voteDetail.showProportion ? '是' : '否' }}</h4>
					<h4>签到未投是否参与占比计算: {{ voteDetail.calculateRule === 0 ? '否' : '是' }}</h4>
				</div>
				<div class="">
					<el-button icon="el-icon-daochu" @click="exportStatusResults">表决结果导出
					</el-button>
				</div>

			</div> -->

			<div style="padding-bottom:50px">
				<div class="box-card" v-for="(item, index) in voteDetailList" :key="index">
					<el-table :data="item.voteDetails" style="width: 100%">
						<el-table-column label-class-name="th_1" fixed="left" align="center" prop="voteName" >
							<template slot="header">
								<div class="" style="">
									{{ item.groupName }}
								</div>
							</template>
						</el-table-column>
						<el-table-column fixed="left" align="center" prop="voteNums" label="全部表决人员" >
							<template slot-scope="scope">{{ scope.row.voteNums ? $formatAmount(scope.row.voteNums):scope.row.voteNums }}</template>
						</el-table-column>
						<el-table-column fixed="left" align="center" prop="voteSigned" 
							:label="meetingData[0].began ? '到会表决人员' : '测试表决人员'">
							<template slot-scope="scope">
								<!-- {{ scope.row.waiver  scope.row.voteSigned}} -->
								<div class="" style="color: #000000;font-weight: bold;">
									{{ scope.row.voteSigned ? $formatAmount(scope.row.voteSigned):scope.row.voteSigned }}
								</div>
								<div class="" style="color: #A6A6A6;margin-top: -20px;">
									{{ keepTwoDecimalFull(scope.row.voteSigned / scope.row.voteNums * 100)}}%
								</div>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>
		</div>
	</el-dialog>
</template>

<script>
	import Pagination from '@/components/Pagination';

	import {
		getVoteResultList,
		getGroupData,
		getVoteResultCount,
		getVoteDetail
	} from '@/serve/userGrouping.js';
	export default {
		components: {
			Pagination
		},
		props: {
			voteResultDialogVisible: Boolean,
			voteDetail: Object,
			voteDetailList: Array,
			meetingData: Array,
			voteLoading: Boolean
		},
		watch: {
			'voteDetail.id'(newVal) {
				if (newVal) {
					this.params = {
						name: '',
						group_id: '',
						amount: '',
						optionId: '',
						page: 0,
						rows: 20,
						sign: '',
						test: '',
					};
					this.activeName = 'first';
					this.getVoteDetail();
					this.getList();

				}
			}
		},
		data() {
			return {
				token: sessionStorage.getItem('ms_token'),
				total: 0,
				tableLoading: false,
				activeName: 'first',
				voteResultDetailList: [],
				params: {
					name: '',
					group_id: '',
					amount: '',
					optionId: '',
					page: 0,
					rows: 20,
					sign: '',
					test: '',
				},
				groups: [],
				voteOptions: [],
				groupData: []
			};
		},
		computed: {
			meetingId() {
				return this.meetingData[0] && this.meetingData[0].id;
			},
		},
		methods: {
			// 四舍五入保留2位小数
			keepTwoDecimalFull(num) {
				let result = parseFloat(num);
				if (isNaN(result)) {
					return false;
				}
				result = Math.round(num * 100) / 100;
				let s_x = result.toString();
				let pos_decimal = s_x.indexOf('.');
				if (pos_decimal < 0) {
					pos_decimal = s_x.length;
					s_x += '.';
				}
				while (s_x.length <= pos_decimal + 2) {
					s_x += '0';
				}
				return s_x;
			},
			// 获取分组组别
			getGroupData() {
				
				getGroupData(this.meetingId)
					.then((res) => {
						console.log('res', res)
						this.groupData = res;
					})
					.catch((err) => {
						this.$message.error(err.data.message);
					});
			},
			// 导出表决统计
			exportStatusResults() {
				let url = `/api/gathering/vote/${this.voteDetail.id}/report/details/export?access_token=` + this.token;
				this.createLabel(url);
			},
			// 导出表决结果
			exportVoteResult() {
				let url =
					`/api/gathering/vote/${this.voteDetail.id}/report/list/export?amount=` +
					this.params.amount +
					'&name=' +
					this.params.name +
					'&keyword=' +
					(this.params.keyword ? this.params.keyword : '') +
					'&test=' +
					this.params.test +
					'&sign=' +
					this.params.sign +
					'&group_id=' +
					this.params.group_id +
					'&optionId=' +
					this.params.optionId +
					'&page=0&rows=' +
					this.total +
					"&access_token=" +
					this.token;
				console.log("url:", url)
				this.createLabel(url);
			},
			createLabel(url) {
				const a = document.createElement('a');
				a.setAttribute('href', url);
				a.setAttribute('download', '表决结果');
				document.body.appendChild(a);
				a.click();
				document.body.removeChild(a);
			},
			// 获取表决详情
			getVoteDetail() {
				getVoteDetail(this.voteDetail.id)
					.then(res => {
						this.groups = res.groups;
						console.log('res.options:', res)
						console.log('res.options', JSON.stringify(res))
						this.voteOptions = res.options;
						let optionIdArray = [];
						res.options.forEach(item => optionIdArray.push(item.id));
						let optionId = optionIdArray.join(",");
						this.voteOptions.push({
							id: optionId,
							voteId: res.options[0].voteId,
							name: '未投'
						});
					})
					.catch(err => {
						this.$message.error(err.data.message);
					});
			},
			onSearch() {
				this.params.page = 0;
				this.params.rows = 20;
				this.getList();
			},
			// 翻页
			turnPage(attr, val) {
				this.params[attr] = val;
				this.getList();
			},
			cancel() {
				this.$emit('cancel');
			},
			handleClick() {
				// this.params = { name: '', group_id: '', amount: '', optionId: '', page: 0, rows: 20 };
				this.activeName = 'first';
				this.getVoteDetail();
				this.getGroupData();
				this.getList();
			},
			// 获取表决详情
			getList() {
				this.tableLoading = true;
				getVoteResultCount(this.voteDetail.id, this.params).then(res => {
					this.total = res;
					if (this.total > 0) {
						getVoteResultList(this.voteDetail.id, this.params)
							.then(res => {
								for (let i = 0; i < res.length; i++) {
									res[i].serialNumber = i + 1;
								}
								this.voteResultDetailList = this.handleTableList(res);
								this.tableLoading = false;
							})
							.catch(err => {
								this.tableLoading = false;
								this.$message.error(err.data.message);
							});
					} else {
						this.voteResultDetailList = [];
						this.tableLoading = false;
					}
				});
			}
		}
	};
</script>
<style scoped lang="scss">
	::v-deep .el-table__fixed-right::before,
	::v-deep .el-table__fixed::before {
		height: 0px !important;
	}
	::v-deep .th_1 {
		background: #73788B !important;
		color: #FFFFFF !important;
	}

	.vote-result-header {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		padding: 5px 0;

		.iconfont {
			color: #bb3a32;
			font-size: 22px;
		}

		.title {
			font-weight: bolder;
		}
	}

	.votestaff-search {
		::v-deep .than {
			margin: 0 1%;
		}
	}

	.vote-result {
		.vote-title {
			width: 63%;
			height: 30px;
			line-height: 30px;
			display: flex;
			justify-content: center;
			align-items: center;
			text-align: left;

			h4 {
				flex: 1;
			}
		}

		.el-card {
			margin-top: 10px;
			height: 500px;
			overflow-y: scroll;


		}

		.vote-result-export {
			position: absolute;
			bottom: 16px;
			height: 50px;
			line-height: 50px;
			padding-left: 30px;
			width: 96%;
			z-index: 999;
			background: #fff;
			box-sizing: border-box;

			.icon-daochu {
				color: #107c41;
				cursor: pointer;
				font-size: 16px;
			}
		}

		// .el-table {
		//     ::v-deep .is-leaf {
		//         background: #c22929 !important;
		//         color: #fff;
		//         text-align: center;
		//     }
		// }

		.box-card {
			padding: 20px 0;
		}

		.clearfix {
			display: flex;
			align-items: center;
			justify-content: flex-start;
			margin: 0 0 15px 0;

			span {
				font-size: 15px;
				font-weight: bold;
			}
		}

		.iconfont {
			// color: #bb3a32;
			font-weight: bolder;
			font-size: 22px;
		}
	}
</style>